import { render, staticRenderFns } from "./addPhotos.vue?vue&type=template&id=252938ba&scoped=true"
import script from "./addPhotos.vue?vue&type=script&lang=js"
export * from "./addPhotos.vue?vue&type=script&lang=js"
import style0 from "./addPhotos.vue?vue&type=style&index=0&id=252938ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252938ba",
  null
  
)

export default component.exports